import { SxProps, Theme } from '@mui/material/styles'

const buttonShadow = '0 10px 24px rgba(47, 45, 39, 0.14)'
const cartAddedBackground = '#198372'
const cartAddedHover = '#146B5E'

export const pageBuilderButtonSx: SxProps<Theme> = theme => ({
  backgroundColor: `var(--page-builder-button-bg, ${theme.palette.primary.main})`,
  color: `var(--page-builder-button-text, ${theme.palette.primary.contrastText})`,
  boxShadow: buttonShadow,
  '&&': {
    backgroundColor: `var(--page-builder-button-bg, ${theme.palette.primary.main})`,
    color: `var(--page-builder-button-text, ${theme.palette.primary.contrastText})`,
  },
  '&:hover': {
    backgroundColor: `var(--page-builder-button-hover, var(--page-builder-button-bg, ${theme.palette.primary.dark}))`,
    boxShadow: buttonShadow,
  },
  '&&:hover': {
    backgroundColor: `var(--page-builder-button-hover, var(--page-builder-button-bg, ${theme.palette.primary.dark}))`,
  },
  '&.Mui-disabled': {
    backgroundColor: `var(--page-builder-button-bg, ${theme.palette.primary.main})`,
    color: `var(--page-builder-button-text, ${theme.palette.primary.contrastText})`,
    opacity: 0.55,
    boxShadow: 'none',
  },
  '&&.Mui-disabled': {
    backgroundColor: `var(--page-builder-button-bg, ${theme.palette.primary.main})`,
    color: `var(--page-builder-button-text, ${theme.palette.primary.contrastText})`,
  },
  '& .MuiButton-startIcon, & .MuiButton-endIcon, & .MuiSvgIcon-root': {
    color: 'inherit',
  },
})

export const pageBuilderPurchaseButtonSx: SxProps<Theme> = theme => ({
  backgroundColor: `var(--page-builder-purchase-button-bg, ${theme.palette.primary.main})`,
  color: `var(--page-builder-purchase-button-text, ${theme.palette.primary.contrastText})`,
  boxShadow: buttonShadow,
  '&&': {
    backgroundColor: `var(--page-builder-purchase-button-bg, ${theme.palette.primary.main})`,
    color: `var(--page-builder-purchase-button-text, ${theme.palette.primary.contrastText})`,
  },
  '&:hover': {
    backgroundColor: `var(--page-builder-purchase-button-hover, var(--page-builder-purchase-button-bg, ${theme.palette.primary.dark}))`,
    boxShadow: buttonShadow,
  },
  '&&:hover': {
    backgroundColor: `var(--page-builder-purchase-button-hover, var(--page-builder-purchase-button-bg, ${theme.palette.primary.dark}))`,
  },
  '&.Mui-disabled': {
    backgroundColor: `var(--page-builder-purchase-button-bg, ${theme.palette.primary.main})`,
    color: `var(--page-builder-purchase-button-text, ${theme.palette.primary.contrastText})`,
    opacity: 0.55,
    boxShadow: 'none',
  },
  '&&.Mui-disabled': {
    backgroundColor: `var(--page-builder-purchase-button-bg, ${theme.palette.primary.main})`,
    color: `var(--page-builder-purchase-button-text, ${theme.palette.primary.contrastText})`,
  },
  '& .MuiButton-startIcon, & .MuiButton-endIcon, & .MuiSvgIcon-root': {
    color: 'inherit',
  },
})

export const pageBuilderCartAddedButtonSx: SxProps<Theme> = theme => ({
  backgroundColor: `var(--page-builder-cart-added-bg, var(--page-builder-success, ${theme.palette.success.main || cartAddedBackground}))`,
  color: `var(--page-builder-cart-added-text, #FFFFFF)`,
  boxShadow: buttonShadow,
  '&:hover': {
    backgroundColor: `var(--page-builder-cart-added-hover, var(--page-builder-success, ${theme.palette.success.dark || cartAddedHover}))`,
    boxShadow: buttonShadow,
  },
  '&.Mui-disabled': {
    backgroundColor: `var(--page-builder-cart-added-bg, var(--page-builder-success, ${theme.palette.success.main || cartAddedBackground}))`,
    color: `var(--page-builder-cart-added-text, #FFFFFF)`,
    opacity: 0.55,
    boxShadow: 'none',
  },
})

export const pageBuilderCartAddedFavoriteButtonSx: SxProps<Theme> = theme => ({
  backgroundColor: `var(--page-builder-cart-added-favorite-bg, var(--page-builder-cart-added-bg, var(--page-builder-success, ${theme.palette.success.main || cartAddedBackground})))`,
  color: `var(--page-builder-cart-added-favorite-text, var(--page-builder-cart-added-text, #FFFFFF))`,
  boxShadow: buttonShadow,
  '&:hover': {
    backgroundColor: `var(--page-builder-cart-added-favorite-hover, var(--page-builder-cart-added-hover, var(--page-builder-success, ${theme.palette.success.dark || cartAddedHover})))`,
    boxShadow: buttonShadow,
  },
  '&.Mui-disabled': {
    backgroundColor: `var(--page-builder-cart-added-favorite-bg, var(--page-builder-cart-added-bg, var(--page-builder-success, ${theme.palette.success.main || cartAddedBackground})))`,
    color: `var(--page-builder-cart-added-favorite-text, var(--page-builder-cart-added-text, #FFFFFF))`,
    opacity: 0.55,
    boxShadow: 'none',
  },
})

export const pageBuilderOutlinedButtonSx: SxProps<Theme> = theme => ({
  color: `var(--page-builder-button-bg, ${theme.palette.primary.main})`,
  borderColor: `var(--page-builder-button-bg, ${theme.palette.primary.main})`,
  '&:hover': {
    color: `var(--page-builder-button-hover, var(--page-builder-button-bg, ${theme.palette.primary.dark}))`,
    borderColor: `var(--page-builder-button-hover, var(--page-builder-button-bg, ${theme.palette.primary.dark}))`,
    backgroundColor: 'color-mix(in srgb, var(--page-builder-button-bg, transparent) 8%, transparent)',
  },
})
